import React from "react";
import Room from "./Room/Room";
const RoomList=(props)=>{
    if(props.sortedRooms.length === 0){
        return(
            <h4 className="text-center mt-4">Unfortunately no rooms matched your search parameters</h4>
        )
    }
    return(
        <React.Fragment>
            <section className="featuredRooms-section">
                <div className="rooms-container">
                    {
                        props.sortedRooms.map(el =>{
                            return(<Room key={el.id} roomObj={el}/>)
                        })
                    }
                </div>
            </section>
        </React.Fragment>
    )
}
export default RoomList;